import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/compress-office/page.tsx");
